import React from "react";
import seminars_articles_en from "./seminars-articles-en.json";
import seminars_articles_tc from "./seminars-articles-tc.json";
import seminars_list_en from "./seminars-list-en.json";

/**
 * Extracts the HTML content from the given JSON data.
 *
 * - For adding new seminars articles, please add in the top of the JSON file(./seminars-articles-en.json and ./seminars-articles-tc.json).
 * - related reference link: https://www.hkctc.gov.hk/events-promotion?section=seminar_article#0
 * - Each item contains a `content` field that holds an HTML string.
 * - If the article has images, please add the images to ./assets/images/seminars/ and update the `img` field in the JSON file.
 *
 * - relatively, also add the new seminars articles into the JSON file(./seminars_list_en.json), related link: https://www.hkctc.gov.hk/events-promotion?section=seminar_workshop
 *
 * @param jsonData - An array of JSON objects, each with a `content` field
 * @returns An array of HTML strings (usually length 1)
 */

type SeminarArticle = {
  title: string;
  date: string;
  content: React.ReactNode;
  topics: { title: string; pdfLink?: string }[];
  subContent: string;
  subtopics: { title: string; pdfLink?: string }[];
  img: string;
};

type SeminarArticleListItem = {
  title: string;
  date: string;
  year: number;
  tag: string;
  id: string;
  img: string;
};

const processSeminarArticlesJson = (jsonData: any[]): SeminarArticle[] => {
  return jsonData?.map((item) => ({
    title: item?.title ?? "",
    date: item?.date ?? "",
    content: item?.content ?? "",
    topics: item?.topics ?? [],
    subContent: item?.subContent ?? "",
    subtopics: item?.subtopics ?? [],
    img: item?.img ?? "",
  }));
};

const processSeminarArticlesListJson = (
  jsonData: any[]
): SeminarArticleListItem[] => {
  return jsonData?.map((item) => ({
    title: item?.title ?? "",
    date: item?.date ?? "",
    year: item?.year ?? 0,
    tag: item?.tag ?? "",
    id: item?.id ?? "",
    img: item?.img ?? "",
  }));
};

export const article_pages_en =
  processSeminarArticlesJson(seminars_articles_en);
export const article_pages_tc =
  processSeminarArticlesJson(seminars_articles_tc);
export const articles_list_en =
  processSeminarArticlesListJson(seminars_list_en);
export const articles_list_cn = articles_list_en.map((item, i) => ({
  ...item,
  title: article_pages_tc[i].title,
  date: article_pages_tc[i].date,
}));
